import { IServiceFactory } from '../../common/types/service-factory';
import { ISegmentsApiService, SegmentsApiService } from '../services/segments-api-service';
import { ApiServiceFactoryBase } from './base/api-service-factory-base';

export class SegmentsApiServiceFactory extends ApiServiceFactoryBase implements IServiceFactory<ISegmentsApiService> {
	public Create(): ISegmentsApiService {
		return new SegmentsApiService(this.apiServiceFactory.Create(), this.appConfigService);
	}
}
